var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-11 px-6 px-2 py-6 text-justify"},[_vm._v(" "+_vm._s(_vm.content.texto)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }